<template>
  <navbar>
    <button
      class="navbar-toggler mobile-sidebar-toggler d-lg-none"
      type="button"
      @click="mobileSidebarToggle"
    >
      &#9776;
    </button>
    <a class="navbar-brand"></a>
    <ul class="nav navbar-nav d-md-down-none">
      <li class="nav-item">
        <a
          class="nav-link navbar-toggler sidebar-toggler"
          @click="sidebarMinimize"
          >&#9776;</a
        >
      </li>
    </ul>

    <ul class="nav navbar-nav d-md-down-none">
      <!---
      <li class="nav-item header-item">


        <router-link tag="div" to='/' style="height:55px;" class="nav-link">
          <p>
            <Icon type="compose" size='30' color="#2d8cf0"></Icon>
          </p>
          <p style="color:white"> 留言管理 </p>
        </router-link>
      </li>
      <li class="nav-item header-item">

        <router-link tag="div" to='/home1' style="height:55px;" class="nav-link">
          <p>
            <Icon type="stats-bars" size='30' color="#2d8cf0"></Icon>
          </p>
          <p style="color:white"> 浏览排行 </p>
        </router-link>


      </li>

      <li class="nav-item header-item">


        <Dropdown>
          <router-link tag="div" to='/' style="height:55px;" class="nav-link">
            <p>
              <Icon type="android-cloud" size='30' color="#2d8cf0"></Icon>
            </p>
            <p style="color:white"> 云服务器 </p>
          </router-link>
          <DropdownMenu slot="list">
            <DropdownItem>Linux</DropdownItem>
            <DropdownItem>Mac OS X</DropdownItem>
            <DropdownItem>Windows</DropdownItem>

            <DropdownItem>Core OS</DropdownItem>
          </DropdownMenu>
        </Dropdown>



      </li>


      <li class="nav-item header-item">


        <router-link tag="div" to='/home1' style="height:55px;" class="nav-link">
          <p>
            <Icon type="trophy" size='30' color="#2d8cf0"></Icon>
          </p>
          <p style="color:white"> 销量排行 </p>
        </router-link>


      </li>

-->
    </ul>

    <ul class="nav navbar-nav ml-auto">
      <!-- <li class="nav-item d-md-down-none">
        <a class="nav-link">
          <Icon type="android-notifications" size="20"></Icon
          ><span class="badge badge-pill badge-danger">5</span>
        </a>
      </li> -->

      <Dropdown class="nav-item">
        <a href="javascript:void(0)">
          <span slot="button">
            <img src="static/img/avatars/6.jpg" class="img-avatar" alt="o" />
            <span class="d-md-down-none">{{username}}</span>
          </span>
        </a>
        <Dropdown-menu slot="list">
          <!-- <Dropdown-item>
            <p class="dropdown-itemp">
              <Icon type="alert"></Icon>Updates<span class="badge badge-info"
                >42</span
              >
            </p>
          </Dropdown-item>
          <Dropdown-item>
            <p class="dropdown-itemp">
              <Icon type="chatbox-working"></Icon>Messages<span
                class="badge badge-success"
                >42</span
              >
            </p>
          </Dropdown-item>
          <Dropdown-item>
            <p class="dropdown-itemp">
              <Icon type="chatbox-working"></Icon>Messages<span
                class="badge badge-danger"
                >42</span
              >
            </p>
          </Dropdown-item>
          <Dropdown-item divided>
            <p class="dropdown-itemp">
              <Icon type="android-contact"></Icon> Profile
            </p>
          </Dropdown-item>
          <Dropdown-item>
            <p class="dropdown-itemp">
              <Icon type="android-settings"></Icon> Settings
            </p>
          </Dropdown-item> -->
          

          <Dropdown-item>
            <p class="dropdown-itemp" @click="showPasswordModal">
              <Icon type="android-settings"></Icon> 修改密码
            </p>
            <a href="" @click="Logout">
              <p class="dropdown-itemp"><Icon type="power"></Icon>Logout</p>
            </a></Dropdown-item
          >
        </Dropdown-menu>
      </Dropdown>

      <!-- 添加修改密码弹窗 -->
      <Modal v-model="showModal" title="修改密码" @on-ok="handleSubmit" @on-cancel="handleCancel">
        <Form ref="passwordForm" :model="formData" :rules="ruleValidate">
          <FormItem label="新密码" prop="password">
            <Input type="password" v-model="formData.password" placeholder="请输入新密码"></Input>
          </FormItem>
          <FormItem label="确认密码" prop="confirmPassword">
            <Input type="password" v-model="formData.confirmPassword" placeholder="请再次输入新密码"></Input>
          </FormItem>
        </Form>
      </Modal>

      <li class="nav-item d-md-down-none">
        <!-- <a
          class="nav-link navbar-toggler aside-menu-toggler"
          @click="asideToggle"
          >&#9776;</a
        > -->
      </li>
    </ul>
  </navbar>
</template>
<script>
import navbar from "./Navbar";
import { getUsername, removeToken } from "../utils/token";
import { updatePassword } from "../api/api";  // 需要添加这个接口

export default {
  name: "headerheader",
  components: {
    navbar,
  },
  data(){
    return{
      username:'',
      showModal: false,
      formData: {
        password: '',
        confirmPassword: ''
      },
      ruleValidate: {
        password: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能小于6位', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { 
            validator: (rule, value, callback) => {
              if (value !== this.formData.password) {
                callback(new Error('两次输入的密码不一致'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ]
      }
    }
  },
  mounted(){
    this.username = getUsername()
  },
  methods: {
    showPasswordModal() {
      this.showModal = true;
      this.formData = {
        password: '',
        confirmPassword: ''
      };
    },
    handleCancel() {
      this.$refs.passwordForm.resetFields();
    },
    handleSubmit() {
      this.$refs.passwordForm.validate((valid) => {
        if (valid) {
          updatePassword(this.username ,this.formData.password).then(res => {
            this.$Message.success('密码修改成功');
            this.Logout();
          }).catch(err => {
            this.$Message.error('密码修改失败：' + err.message);
          });
        } else {
          this.$Message.error('请正确填写表单内容');
        }
      });
    },
    Logout(e) {
      this.$router.push({ path: "/login" });

      removeToken();
      // e.preventDefault();
      // this.$store
      //   .dispatch("LogOut")
      //   .then(() => {
      //     this.$router.push({ path: "/login" });
      //   })
      //   .catch((err) => {
      //     this.$message.error(err);
      //   });
    },
    click() {
      // do nothing
    },
    sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle("sidebar-hidden");
    },
    sidebarMinimize(e) {
      e.preventDefault();

      document.body.classList.toggle("sidebar-minimized");
    },
    mobileSidebarToggle(e) {
      e.preventDefault();

      document.body.classList.toggle("sidebar-mobile-show");
    },
    asideToggle(e) {
      e.preventDefault();
      document.body.classList.toggle("aside-menu-hidden");
    },
  },
};
</script>

<style type="text/css" scoped>
.dropdown-itemp {
  text-align: left;
  font-size: 15px;
  padding: 10px;
}

.header-item .ivu-dropdown-item {
  padding: 15px;
}

.header-item {
  width: 130px;
  /*background-color: #20a8d8;*/
  /*background-color: white;*/

  height: 55px;
}

.header-item a {
  color: white !important;
}
</style>
